
/**
 * 网络请求配置
 */
import qs from 'qs';
import {
    Toast,
} from 'antd-mobile';
import { detectUserPlatform } from './util';
import axios from "axios";
import envConfig from '../config/env';
// 环境地址统一在 src/config/env.js 中配置切换，不要再在这里改域名
let urlWeb = envConfig.apiManage
let url2 = envConfig.apiGuardian
let url_user = envConfig.api
let url_cas = envConfig.cas
export const url_xc = envConfig.xc
export const url_kh = envConfig.kh
axios.defaults.timeout = 100000;
/**
 * http request 拦截器
 */
axios.interceptors.request.use(
    (config) => {
        const token = window.localStorage.getItem('token') || window.localStorage.getItem('token') || ""
        config.headers = {
            'Authorization': token ? token : '',
            "Content-Type": "application/json",
        };
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

/**
 * http response 拦截器
 */
axios.interceptors.response.use(
    (response) => {
        console.log(response, 'response');
        return response;
    },
    error => {
        if (error.response) {

            switch (error.response.status) {
                case 401:
            }
        }
        return Promise.reject(error.response)   // 返回接口返回的错误信息
    }
);

/**
 * 封装get方法
 * @param url  请求url
 * @param params  请求参数
 * @returns {Promise}
 */
export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        Toast.show({
            icon: 'loading',
            content: '加载中…',
        })
        // 检测用户平台环境，如果params中已经有phoneSystem且不为null，则使用它；否则自动检测
        const platform = detectUserPlatform(params?.phoneSystem);
        // 只有在phoneSystem不为null时才设置
        if (platform && params) {
            params.phoneSystem = platform;
        } else if (platform && !params) {
            // 检查URL中是否已包含phoneSystem参数，避免重复添加
            if (!url.includes('phoneSystem=')) {
                if (url.includes('?')) {
                    url = url + '&phoneSystem=' + platform;
                }
            }
        }
        axios.get(url, {
            params: params,
        }).then((response) => {
            Toast.clear()
            resolve(response.data);
        })
            .catch((error) => {
                // if (error.status == '401') {
                //     Toast.show({
                //         content: '用户未注册',
                //     })
                // }else{
                //     Toast.show({
                //         content: '状态码：'+error.status,
                //     })
                // }
                // Toast.show({
                //     content: '状态码：'+error.status,
                // })
                reject(error);
            });
    });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data) {
    return new Promise((resolve, reject) => {
        Toast.show({
            icon: 'loading',
            content: '加载中…',
        })
        // 检测用户平台环境，如果data中已经有phoneSystem且不为null，则使用它；否则自动检测
        const platform = detectUserPlatform(data?.phoneSystem);
        // 只有在phoneSystem不为null时才设置
        if (platform && data) {
            data.phoneSystem = platform;
        } else if (platform && !data) {
            // 检查URL中是否已包含phoneSystem参数，避免重复添加
            if (!url.includes('phoneSystem=')) {
                if (url.includes('?')) {
                    url = url + '&phoneSystem=' + platform;
                }
            }
        }
        axios.post(url, data).then(
            (response) => {
                Toast.clear()
                resolve(response.data);
            },
            (err) => {
                Toast.show({
                    content: '系统错误',
                })
                reject(err);
            }
        );
    });
}
/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
    return new Promise((resolve, reject) => {
        Toast.show({
            icon: 'loading',
            content: '加载中…',
        })
        axios.put(url, data).then(
            (response) => {
                Toast.clear()
                resolve(response.data);
            },
            (err) => {
                Toast.show({
                    content: '系统错误',
                })
                reject(err);
            }
        );
    });
}
//统一接口处理，返回数据
export default function (fecth, url, param, bill, web) {

    if (bill) {
        axios.defaults.baseURL = url2
    }
    if (web) {
        axios.defaults.baseURL = urlWeb
    }
    if (!bill && !web) {
        axios.defaults.baseURL = url_user
    }
    console.log(bill, web, axios.defaults.baseURL)
    return new Promise((resolve, reject) => {
        switch (fecth) {
            case "get":
                console.log("begin a get request,and url:", url);
                console.log(url, param, '参数')
                get(url, param)
                    .then(function (response) {
                        resolve(response);
                    })
                    .catch(function (error) {
                        console.log("get request GET failed.", error);
                        reject(error);
                    });
                break;
            case "post":
                post(url, param)
                    .then(function (response) {
                        resolve(response);
                    })
                    .catch(function (error) {
                        console.log("get request POST failed.", error);
                        reject(error);
                    });
                break;
            case "put":
                put(url, param)
                    .then(function (response) {
                        resolve(response);
                    })
                    .catch(function (error) {
                        console.log("get request put failed.", error);
                        reject(error);
                    });
                break;
            default:
                break;
        }
    });
}
